import React from 'react';

const DocumentWithRightArrowIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' {...props}>
    <g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 6C5.34315 6 4 7.34315 4 9V23C4 24.6569 5.34315 26 7 26H17C18.6569 26 20 24.6569 20 23V9C20 7.34315 18.6569 6 17 6H7ZM16 16C16.2761 16 16.5 16.2239 16.5 16.5C16.5 16.7455 16.3231 16.9496 16.0899 16.9919L16 17H7.5C7.22386 17 7 16.7761 7 16.5C7 16.2545 7.17688 16.0504 7.41012 16.0081L7.5 16H16ZM11.5 19C11.7761 19 12 19.2239 12 19.5C12 19.7455 11.8231 19.9496 11.5899 19.9919L11.5 20H7.5C7.22386 20 7 19.7761 7 19.5C7 19.2545 7.17688 19.0504 7.41012 19.0081L7.5 19H11.5ZM7 11C7 10.4477 7.44772 10 8 10H10C10.5523 10 11 10.4477 11 11V13C11 13.5523 10.5523 14 10 14H8C7.44772 14 7 13.5523 7 13V11ZM27.8066 14.2197L27.7298 14.1525C27.4358 13.9288 27.0144 13.9512 26.7459 14.2197L26.6788 14.2965C26.4551 14.5904 26.4774 15.0118 26.7459 15.2803L27.135 15.67L23 15.6709C22.4477 15.6709 22 16.1186 22 16.6709C22 17.2231 22.4477 17.6709 23 17.6709L27.184 17.67L26.9436 17.9113L26.8765 17.9881C26.6527 18.2821 26.6751 18.7035 26.9436 18.972C27.2365 19.2649 27.7113 19.2649 28.0042 18.972L30.2816 16.6947L27.8066 14.2197Z'
        fill='currentColor'
      />
    </g>
  </svg>
);

export default DocumentWithRightArrowIcon;
